import { defineField, defineType } from 'sanity'

export default defineType({
  title: 'Carousel',
  name: 'wheelLandingCarousel',
  type: 'object',
  fields: [
    defineField({
      name: 'diameter',
      title: 'Wheel Diameter',
      type: 'reference',
      to: [{ type: 'diameter' }],
      options: {
        disableNew: true,
      },
    }),
    defineField({
      name: 'profile',
      title: 'Wheel Profile',
      type: 'reference',
      to: [{ type: 'profile' }],
      options: {
        disableNew: true,
      },
    }),
    defineField({
      name: 'lugs',
      title: 'Lugs',
      type: 'reference',
      to: [{ type: 'lug' }],
      options: {
        disableNew: true,
      },
    }),
    defineField({
      name: 'centerCap',
      title: 'Center Cap',
      type: 'reference',
      to: [{ type: 'centerCap' }],
      options: {
        disableNew: true,
      },
    }),
  ],
})